/**
 * TransactionActionBar · txn kit (presentation only)
 * Sticky bottom action bar with a consistent hierarchy: left slot for
 * document/status context, right slot for actions (Back/Cancel → Save Draft →
 * primary irreversible action). Renders slots only — callers wire handlers,
 * permissions and lifecycle semantics. No logic.
 */
import React from "react";

export default function TransactionActionBar({
  left = null,
  children,
  sticky = true,
  className = "",
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`${
        sticky ? "sticky bottom-0 z-10" : ""
      } flex items-center justify-between gap-3 flex-wrap px-4 py-3 bg-[var(--bg-1)]/95 backdrop-blur border-t border-[var(--border)] rounded-b-md ${className}`}
    >
      <div className="flex items-center gap-2 min-w-0 text-xs text-[var(--fg-2)]">{left}</div>
      <div className="flex items-center gap-2 flex-wrap justify-end">{children}</div>
    </div>
  );
}
